import { Trans } from '@lingui/react/macro';

import CheckIcon from '@/assets/svg/bx-check.svg?react';
import CrossIcon from '@/assets/svg/bx-x.svg?react';
import { Text } from '@/components/typography';
import { numberFormat } from '@/helper/numberFormatter';

type IntegrationStatus = 'active' | 'notConnected' | 'broken';

type Props = {
  status: IntegrationStatus;
  count?: number;
};

const getStatusText = (status: IntegrationStatus, count?: number) => {
  let statusText = <Trans>Error</Trans>;
  if (status === 'active') {
    statusText = <Trans>Connected</Trans>;
  } else if (status === 'notConnected') {
    statusText = <Trans>Not Connected</Trans>;
  }

  if (count == null || status === 'notConnected') {
    return statusText;
  }

  return (
    <Trans>
      {statusText} ({numberFormat(count)})
    </Trans>
  );
};

const IntegrationStatus = ({ status, count }: Props) => {
  const statusContent = getStatusText(status, count);

  return (
    <Text
      className="flex items-center"
      variant="footnote"
      color={status === 'active' ? 'green' : 'red'}
    >
      <span className="flex size-6 shrink-0 items-center justify-center">
        {status === 'active' ? <CheckIcon /> : <CrossIcon />}
      </span>
      {statusContent}
    </Text>
  );
};

export default IntegrationStatus;
